import React, { useState, useRef } from "react";
import classNames from 'classnames';
import { CSSTransition } from "react-transition-group";
import "./SearchInput.scss";

import { ReactComponent as SearchIcon } from 'static/icons/search-grey.svg';
import { ReactComponent as CloseIcon } from 'static/icons/close-small.svg';

const SearchInput = (
  ({
    name,
    type,
    size,
    placeholder,
    isVisible,
    isWithoutCloseButton,
    isAbsolutePositioning,
    isRightPosition,
    width,
    onChange,
    value,
    onChangeVisibility,
    onHideSearch,
    className,
  }) => {
    const inputRef = useRef();
    const [searchFocused, setSearchFocused] = useState(false);

    const handleSearchFocus = () => {
      setSearchFocused(true);
    };

    const handleSearchBlur = () => {
      setSearchFocused(false);
    };

    const handleChangeVisibility = () => {
      if (!searchFocused) {
        inputRef.current.focus();
      }

      onChangeVisibility?.();
    };

    const handleHideSearch = () => {
      inputRef.current.value = null;
      onHideSearch?.();
    };

    return (
      <div
        className={classNames(className, {
          "search-input": true,
          "search-input--md": size === 'md',
          "search-input--absolute": isAbsolutePositioning,
          "search-input--right": isRightPosition,
          "search-input--visible ": isVisible,
          "search-input--visible-right": isVisible && isAbsolutePositioning,
          "search-input--hidden": !isVisible,
          "search-input--focused ": isVisible && searchFocused,
        })}
      >
        <SearchIcon
          className={classNames({
            'search-input__icon_search': true,
            'search-input__icon_search--md': size === 'md',
            'search-input__icon_search--visible': isVisible,
            'search-input__icon_search--focused': searchFocused,
            'search-input__icon_search--notvisible': !isVisible,
          })}
          onClick={handleChangeVisibility}
        />

        <input
          ref={inputRef}
          type={type}
          name={name}
          className={classNames({
            "search-input__input": true,
            "search-input__input--md": size === 'md',
            "search-input__input--visible": isVisible,
            "search-input__input--hidden": !isVisible,
            "search-input__input--focused": isVisible && searchFocused,
            'search-input__input--focused-md': isVisible && searchFocused && size === 'md',
          })}
          style={isVisible
            ? searchFocused
              ? size === 'md'
                ? { width: width - 50 + 30 }
                : { width: width - 50 + 34 }
              : { width: width - 50 }
            : null}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={handleSearchFocus}
          onBlur={handleSearchBlur}
        />

        <CSSTransition
          in={isVisible && !isWithoutCloseButton}
          timeout={150}
          unmountOnExit
          classNames="search-input__icon_close"
        >
          <CloseIcon
            className={classNames({
              'search-input__icon_close': true,
              'search-input__icon_close--visible': isVisible,
              'search-input__icon_close--hidden': !isVisible,
              'search-input__icon_close--focused': isVisible && searchFocused,
            })}
            onClick={handleHideSearch}
          />
        </CSSTransition>
      </div>
    );
  }
);

export default SearchInput;
